import { useLingui } from "@lingui/react/macro";
import { Skeleton } from "@offstreetparking/design-system/feedback";
export const ParkingDetailsSkeleton = () => {
	const { t } = useLingui();
	return (
		<div aria-busy="true" aria-live="polite">
			<span className="sr-only">{t`Loading parking details`}</span>
			<div className="flex flex-col gap-4">
				<div className="flex flex-col items-center justify-center gap-2 rounded-t-md bg-black p-2">
					<Skeleton height={20} width={96} className="bg-neutral-faded" />
					<Skeleton height={20} width={128} className="bg-neutral-faded" />
				</div>
			</div>

			<div className="flex flex-col gap-8 p-8">
				<Skeleton height={24} width={200} />

				{/* Location */}
				<div className="flex gap-4">
					<Skeleton height={24} width={24} type="circle" />
					<div className="flex-1">
						<Skeleton height={24} width={192} />
						<Skeleton height={16} width={128} className="mt-1" />
					</div>
				</div>

				{/* Cost */}
				<div className="flex gap-4">
					<Skeleton height={24} width={24} type="circle" />
					<div className="flex-1">
						<Skeleton height={24} width={192} />
						<Skeleton height={16} width={128} className="mt-1" />
					</div>
				</div>
			</div>

			{/* Vehicle, Email, and Instructions*/}
			<div className="flex flex-col gap-8 p-8">
				<Skeleton height={24} width={192} />

				<div className="flex w-full">
					<Skeleton height={32} width={336} />
					<Skeleton height={32} width={336} />
				</div>

				<div className="flex gap-4">
					<Skeleton height={24} width={24} type="circle" />
					<Skeleton height={32} width={544} />
				</div>

				<div className="flex gap-4">
					<Skeleton height={24} width={24} type="circle" />
					<Skeleton height={48} width={544} />
				</div>
			</div>

			<div className="flex justify-end pr-8 pb-8">
				<Skeleton width={160} height={36} />
			</div>
		</div>
	);
};
